import React from 'react'

export const JobSkeleton = () => {
  return (
    <div className='skeletonPulse' />
  )
}
